import React, { useEffect, useState } from 'react';
import { LOCATIONS } from './constants';
import { Link } from 'react-router-dom';

function Nav() {
    const [scrolledDown, setScrolledDown] = useState(false);
    useEffect(() => {
        window.addEventListener('scroll', () => {
            setScrolledDown(window.scrollY > 10);
        });

        // Copied from static project
        // The navbar on mobile and small screens won't go away when clicking anchors in dropdowns, so we manually close them
        const navLinksToAutoCollapse = document.querySelectorAll('#navbarNav .nav-item.dropdown .dropdown-menu a.dropdown-item, #navbarNav .nav-item a.nav-link');
        navLinksToAutoCollapse.forEach((navLink) => {
            // Only do this logic on links that have an anchor and be safe about it
            if (navLink.href) {
                navLink.addEventListener('click', (event) => {
                    const navBar = document.querySelector('#navbarNav');
                    navBar && navBar.classList.remove('show');
                    const navToggleBtn = document.querySelector('#mainNavbar button.navbar-toggler');
                    navToggleBtn && navToggleBtn.classList.remove('collapsed');
                });
            }
        });
    }, []);

    const locationItems = LOCATIONS.map((location, locationIndex) => {
        const locationNum = locationIndex + 1;
        const { address } = location;
        const str = `#${String(locationNum)}:`.padEnd(5, ' ').replaceAll(' ', '&nbsp;');
        const html = `${str} ${address}`;
        return (
            <li key={`location${locationNum}`}>
                <Link to={`/location/${locationNum}`} className="dropdown-item" dangerouslySetInnerHTML={{ __html: html }}></Link>
            </li>
        );
    });

    const navbarClasses = `navbar navbar-expand-lg fixed-top navbar-light ${scrolledDown ? 'scrolled-down' : ''}`;

    return (
        <nav id="mainNavbar" className={navbarClasses} aria-label="Main navigation">
            <div className="container">
                <div className="navbar-brand placard">
                    <div className="row align-items-center">
                        <div className="col">
                            <Link to={`/`}><img src="./img/MNINY_AudioBook_cover_350.webp" alt="CD Cover"/></Link>
                        </div>
                        <div className="col">
                            <div className="row">
                                <div className="col">
                                    <Link to={`/`} className="title">My Name is New York</Link>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <Link to={`/`} className="narrated-by">By Nora Guthrie</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button className="navbar-toggler p-0 border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false"
                        aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div id="navbarNav" className="navbar-collapse offcanvas-collapse">
                    <ul className="navbar-nav ms-auto navbar-nav-scroll">
                        <li className="nav-item">
                            <Link to={`/`} className="nav-link">Home</Link>
                        </li>
                        <li className="nav-item dropdown">
                            <span className="nav-link dropdown-toggle" id="dropdownAbout" role="button" data-bs-toggle="dropdown" aria-expanded="false">Locations</span>
                            <ul className="dropdown-menu" aria-labelledby="dropdownAbout">
                                <li>
                                    <Link to={{
                                        pathname: `/`,
                                        hash: '#locationList',
                                    }} className="dropdown-item">All Locations</Link>
                                    {/*<a href="/#locationList" className="dropdown-item">All Locations</a>*/}
                                </li>
                                {locationItems}
                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link to={`/songs`} className="nav-link">Songs</Link>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link btn btn-primary btn-solid-sm" role="button" href="https://store.woodyguthrie.org/products/my-name-is-new-york-book-3-cd-set">Purchase <i className="bi bi-cart"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Nav;
